module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1X7D8"))).then(() => module.bundle.root('3a9aZ'));